export default __webpack_public_path__ + "static/landloard-b4003032d73c0a2cb947c6e65a8e2489.png";